import { CircularProgress } from '@mui/material';

export default function CircularSpinner({ color, size, ...others }) {
    return <CircularProgress color={color || 'primary'} size={size || '3rem'} {...others} />;
}
